import Carne from "./Carne";

export default Carne;
